import {Component, Input} from '@angular/core';
import {OnboardingType} from '../../enums/onboarding-type';
import {MessagesService} from '../../services/messages.service';
import {EmbeddedSignupService} from '../../services/embedded-signup.service';
import {MessageType} from '../../enums/message-type';

@Component({
  selector: 'app-start-embedded-signup-button',
  imports: [],
  templateUrl: './start-embedded-signup-button.component.html',
  styleUrl: './start-embedded-signup-button.component.scss'
})
export class StartEmbeddedSignupButtonComponent {
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('onboarding-type')
  public onboardingType: OnboardingType | undefined = undefined;

  public constructor(
    private readonly messagesService: MessagesService,
    private readonly embeddedSignupService: EmbeddedSignupService
  ) {
  }

  public startEmbeddedSignup(event: Event): void {
    switch (this.onboardingType) {
      case OnboardingType.WHATSAPP:
        this.embeddedSignupService.launchWhatsAppSignup(event);
        break;

      case OnboardingType.INSTAGRAM:
        this.embeddedSignupService.launchInstagramSignup(event);
        break;
      case OnboardingType.MESSENGER:
        this.embeddedSignupService.launchMessengerSignup(event);
        break;

      default:
        this.messagesService.addMessage({
          type: MessageType.ERROR,
          message: `Unknown embedded signup type: ${this.onboardingType}`
        });
        break;
    }
  }
}
